/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const CheckoutStatus = zod.enum(['open', 'closed']);

export type CheckoutStatus = zod.input<typeof CheckoutStatus>;
export type CheckoutStatusOutput = zod.output<typeof CheckoutStatus>;
